<template>
  <div>
      <div class="pannel">
            <div class="title">{{$t('way1')}}:</div>
          <div class="type1">
            <img :src="qrImage" alt="">
          </div>
          <div class="type2" style="display: none">{{$t('way2')}}:</div>
            <el-form ref="ruleForm"  label-width="80px" :model="form" :rules="rules"  style="display: none"> 
                <!--  -->
                <!-- 姓名 -->
                <el-form-item :label="$t('name')" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>


<!-- // 联系方式 -->
                <el-form-item :label="$t('contactinformation')" prop="mobile">
                    <el-input type="number" v-model="form.mobile"></el-input>
                </el-form-item>

<!-- 验证码 -->
                <!-- <el-form-item :label="$t('verificationCode')" prop="verification_code" v-if="!id">
                    <el-input v-model.number="form.verification_code" type="number">
                        <template slot="append">
                            
                            <span class="get-code" v-if="verificationMsg" @click="getCode">{{$t('getVerificationCode')}}</span>
                            <span class="get-code" v-else>{{timerMsg}}</span>
                        </template>
                    </el-input>
                </el-form-item> -->

<!--  -->
<!-- 返点设置 -->
                <el-form-item :label="$t('rebatesSet')" prop="rebate">
                    <el-input v-model="form.rebate" type="number"> 
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>

<!-- state -->
                <el-form-item :label="$t('state')">
                    <el-radio v-model="form.status" :label="1">{{$t('enable')}}</el-radio>
                    <el-radio v-model="form.status" :label="2">{{$t('disable')}}</el-radio>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit('ruleForm')">{{$t('submit2')}}</el-button>
                </el-form-item>
            </el-form>
      </div>
  </div>
</template>

<script>
import {apiBaseUrl} from '@/config/env.js'
export default {
    data() {
        return {
            rules: {
                name: [
                    { required: true, message: this.$t('enterYourname'), trigger: 'blur' },
                    { min: 1, max: 20, message: this.$t('charLenth'), trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: this.$t('phonenumber'), trigger: 'blur' },
                ],
                // verification_code: [
                //     { required: true, message: this.$t('pEvalidation'), trigger: 'blur' },
                // ],
                rebate: [
                    { required: true, message: this.$t('rebatesSet'), trigger: 'blur' },
                    { pattern: /^([0-9]|[0-9]\.\d+|[1-9][0-9]|[1-9][0-9]\.\d+|100)$/, message: '0-100的值', trigger: 'blur' }
                ],
            },
            form: {
                business_id: '',
                name: '',
                mobile: '',
                // verification_code: '',
                rebate:'',
                status: 1
            },
            id: '', // 员工id
            timerMsg: 60, // 定义初始时间为60s
			auth_timer: null,
            verificationMsg: true,
            qrImage: ''
        }
    },
    methods: {
        init() {
            this.$api.getstaffinfo({
				id: this.id
			}).then(res => {
				if(res.status) {
					let data = res.data
					this.form = {
						...this.form,
						name: data.name,
						mobile: data.mobile,
						rebate: data.rebate ,// 返点
						status: data.status
					}
				}
			})
        },
        // 表单提交
        onSubmit(formName) {
            const _this = this
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    _this.submit()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        submit() {

            
            // 修改
			if(this.id) {
				this.$api.savestaff({...this.form, id: this.id}).then(res => {
					if(res.status) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })

                        this.$router.push({
                            name: 'staff',
                        })
					} else {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
					}
				})
			} else{
				// 添加
				this.$api.addstaff(this.form).then(res => {
					if(res.status) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.$router.push({
                            name: 'staff',
                        })
					} else {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
					}
				})
			}
        },
        // 获取验证码
        getCode() {
            let phone = this.form.mobile
			if(!phone) {
                this.$message({
                    message: this.$t('phonenumber'),
                    type: "error"
                })
				return
			}
			
			const  _this = this
			this.$api.sms({
				mobile: phone,
				code: 'veri',
				token: localStorage.getItem('userToken') 
			}).then(res => {
                if(res.status) {
					_this.timerMsg = 60
					_this.verificationMsg = false
					_this.countDown()
				} else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    })
				}
            })
        },
        countDown() {
			const _this = this
			this.auth_timer = setInterval(() => {
				// 定时器设置每秒递减
				this.timerMsg--; // 递减时间
                localStorage.setItem('timerCardStaff', this.timerMsg)
				if (this.timerMsg <= 0) {
					_this.timerCardStaff = 60
					_this.verificationMsg = true; // 60s时间结束还原v-show状态并清除定时器
                    localStorage.removeItem('timerCardStaff')
					clearInterval(this.auth_timer);
					this.auth_timer = null
				}
			}, 1000);
		},
    },
    mounted() {
        // 
        this.form.business_id = localStorage.getItem('businessId') || ''
        let data =  {
            client: 1,
            page: 12,
            params: {id: localStorage.getItem('businessId') - 0},
            token: this.$storage.get('userToken'),
            type: 3,
            url: apiBaseUrl + "wap/pages/share/jump"
        }

        
        this.$api.share(data).then(res => {
            if(res.status) {
                this.qrImage = res.data
            }
        })
        if(this.$route.query.id) {
            this.id = this.$route.query.id
            this.init()

        }
    }
}
</script>

<style lang="scss" scoped>
    .type1{
        img{
            margin-left: 50px;
            width: 250px;
            height: 250px;
        }
    }
    .el-form {
        width: 600px;
    }
    .fr-btn{
        position: absolute;
        top: 50%;
        right: -160px;
        transform: translate(-50%, -50%);
    }
    .get-code{
        cursor: pointer;
    }
    .type2{
        margin-top: 50px;
        margin-bottom: 20px;
    }
</style>